/* eslint-disable @typescript-eslint/no-explicit-any */

const PIXEL_ID = '2832673310418578'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (initialized) return

  try {
    if (!window.fbq) {
      const n: any = function (...args: any[]) {
        if (n.callMethod) {
          n.callMethod.apply(n, args)
        } else {
          n.queue.push(args)
        }
      }
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      window.fbq = n
      if (!window._fbq) window._fbq = n

      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      const first = document.getElementsByTagName('script')[0]
      if (first && first.parentNode) {
        first.parentNode.insertBefore(script, first)
      } else {
        document.head.appendChild(script)
      }
    }

    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
    initialized = true
  } catch (err) {
    console.warn('[MetaPixel] init failed', err)
  }
}

/**
 * Fire a standard Meta Pixel event.
 * Common events: 'InitiateCheckout', 'Purchase', 'Lead', 'AddToCart', 'ViewContent'
 */
export function trackEvent(event: string, data?: Record<string, unknown>) {
  if (typeof window === 'undefined' || !window.fbq) return
  try {
    window.fbq('track', event, data)
  } catch (err) {
    console.warn('[MetaPixel] trackEvent failed', err)
  }
}

/**
 * Fire a custom (non-standard) Meta Pixel event.
 */
export function trackCustomEvent(
  event: string,
  data?: Record<string, unknown>,
) {
  if (typeof window === 'undefined' || !window.fbq) return
  try {
    window.fbq('trackCustom', event, data)
  } catch (err) {
    console.warn('[MetaPixel] trackCustomEvent failed', err)
  }
}
